import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

interface ClassViewConfigOptions {}

export const getClassViewConfig = (options: ClassViewConfigOptions = {}): FtuxConfig => {
	const steps: FtuxStep[] = [
		{
			type: 'modal' as const,
			title: 'Managing classes and students',
			subtitle:
				'In the class view, you can add students to the platform and assign eLibrary books for them. You will also be able to monitor student progress for each book that has been assigned to them.',
			image: '/img/ftux-class-1.png',
			button: {
				label: 'Next',
				type: 'paginated' as const,
				hasBackButton: false
			},
			modalPosition: 'bottom-right' as const,
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#add-more-students-button',
			subtitle: 'Add students to a class by clicking here.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#print-id-cards-button',
			subtitle:
				'You can click here to get a PDF printout with all login details for all students in the class. Students can use the login details to access the student eLibrary and any books assigned to them.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#students-table',
			subtitle:
				'Any students in your class will appear here. You can click on any student to manage their individual records.',
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#current-stage',
			subtitle:
				'The <strong>highest stage completed, books completed</strong> and <strong>assigned books</strong> are listed here.',
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#student-menu',
			subtitle: 'Click here to <strong>assign books, transfer classes</strong> or <strong>archive a student</strong>.',
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#student-details-button',
			subtitle: 'Click here to see a student’s full profile with account details and book assignments.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		}
	];

	const config: FtuxConfig = {
		id: 'class-view-ftux',
		name: 'Class View Tutorial',
		showSkipButton: false,
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
